export default __webpack_public_path__ + "static/media/gallery_07.b55a3498.jpg";